<div *ngFor="let attachment of fileList; let i = index" class="attachment-element" [ngClass]="{ 'with-size': showFileSize }">
  <ng-container *ngTemplateOutlet="icon"></ng-container>
  <div class="attachment-name">
    <b *ngIf="showNewText">[{{ 'button.new' | loc }}]</b>
    <ng-container *ngIf="getLocalFileUrl(attachment) as localFileUrl; else plainFileName">
      <a [href]="localFileUrl" class="mat-black" target="_blank" rel="noopener noreferrer">
        {{ attachment.name }}
      </a>
    </ng-container>
    <ng-template #plainFileName>{{ attachment.name }}</ng-template>
  </div>
  <div *ngIf="showFileSize" class="file-size">{{ attachment.file!.size | fileSize }}</div>
  <ng-container *ngTemplateOutlet="deleteButton; context: { index: i }"></ng-container>
</div>

<div
  *ngFor="let attachment of showFileSize ? structListWithSize : structList; let i = index"
  class="attachment-element"
  [ngClass]="{ 'with-size': showFileSize }"
>
  <ng-container *ngTemplateOutlet="icon"></ng-container>
  <div class="attachment-name">
    <a
      [href]="attachment.downloadUrl ?? (attachment.storagePath | getStorageURL)"
      class="mat-black"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ attachment.name }}
    </a>
  </div>
  <div *ngIf="showFileSize" class="file-size">{{ attachment.size | fileSize }}</div>
  <ng-container *ngTemplateOutlet="deleteButton; context: { index: i }"></ng-container>
</div>

<ng-template #icon>
  <div class="icon {{ colors }}">
    <app-avatar icon="attach_file" [iconSize]="16" [containerSize]="32" containerColor="primary" iconColor="white"></app-avatar>
  </div>
</ng-template>

<ng-template #deleteButton let-index="index">
  <div class="delete-button {{ colors }}" *ngIf="!disabled">
    <mat-icon color="primary" class="cursor-pointer" (click)="onDelete.emit(index)">delete_outline</mat-icon>
  </div>
</ng-template>
